// @mui
import { Popover, PopoverOrigin, useTheme } from '@mui/material';
//
import getPosition from './getPosition';
import { StyledArrow } from './styles';
import { MenuPopoverProps } from './types';
// ----------------------------------------------------------------------

export function MenuPopover({
  open,
  children,
  arrow = 'top-right',
  disabledArrow,
  width = 'auto',
  sx,
  ...other
}: MenuPopoverProps) {
  const { style, anchorOrigin, transformOrigin } = getPosition(arrow);
  const theme = useTheme();

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      anchorOrigin={anchorOrigin as PopoverOrigin}
      transformOrigin={transformOrigin as PopoverOrigin}
      PaperProps={{
        sx: {
          px: 0.5,
          py: 1,
          backgroundColor: theme.palette.background.default,
          width: width,
          overflow: 'inherit',
          ...style,
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 2, width: 16, height: 16, flexShrink: 0, marginRight: '8px' },
          },
          ...sx,
        },
      }}
      {...other}
    >
      {!disabledArrow && <StyledArrow arrow={arrow} />}

      {children}
    </Popover>
  );
}
